import { NotiApi } from 'api/ApiHelper';
import { notiQueryKey } from 'queries/noti/queryKey';
import { useMutation, useQueryClient } from '@tanstack/react-query';

export const useReadAllInboxNotificationsMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: notiQueryKey.read,
    mutationFn: () => NotiApi.readAllInboxNotifications(),
    onMutate: () => {
      queryClient.setQueryData(notiQueryKey.unreadCount(), { unreadCount: 0 });
    },
  });
};
